import React, { useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';
import classNames from 'classnames';

import useStyles from './useStyles';
import Sidebar from './Sidebar';
import TopNav from './TopNav';

import { useParams, useSearchParams } from '@/router/hooks';
import { cn } from '@/utils';
import { useNovelCoreStore } from '@/stores/novelCoreStore';
import { AppLoader } from '@/components/AppLoader';
import ChapterGateRail from '@/components/ChapterGateRail';
const NovelLayout: React.FC = () => {
  const { styles } = useStyles();
  const searchParams = useSearchParams();
  const { initNovelDetailsById } = useNovelCoreStore()
  const [isInitialized, setIsInitialized] = useState(false);
  const { novelId } = useParams()

  /** 与 Sidebar 一致：默认收起，sidebar=open 才展开 */
  const sidebarHidden = useMemo(() => {
    return searchParams.get('sidebar') !== 'open';
  }, [searchParams]);

  useEffect(() => {
    if (!novelId) return
    initNovelDetailsById(novelId).then(() => {
      setIsInitialized(true)
    })
  }, [novelId])

  if (!isInitialized) return <AppLoader message="论文台加载中..." />


  return (
    <div className={classNames(styles.novelWorkspace, "flex-col lg:flex-row")}>
      <Sidebar className={styles.novelWorkspaceSidebar} />
      <main
        className={cn(
          "thesis-workspace-main flex grow overflow-hidden flex-col min-w-0",
          "bg-[var(--tt-bg,#f2f0eb)]",
          /* 小屏：开题卡展开时仍可切回正文；仅桌面在开题卡全宽时隐藏 main */
          !sidebarHidden && "max-lg:hidden lg:flex",
        )}
      >
        {/* 顶栏全宽，不被右侧契约轨挤走个人中心 */}
        <TopNav />
        <div className="grow flex min-h-0 overflow-hidden flex-row">
          <div className="grow overflow-hidden flex flex-col @container min-w-0">
            <Outlet />
          </div>
          <ChapterGateRail />
        </div>
      </main>
    </div>
  );
};


export default NovelLayout;
